import { Widget, ChartType } from 'genesis-suite/types/visualTypes'

export default function checkShouldPaginate(config: Widget) {
    if (config.type !== ChartType.TABLE) return false
    if (config.categories?.length) return false
    if (config.series[0]?.subSeries) return false

    return true
}
